export default "__VITE_ASSET__DZwKv4$4__"